import { NgModule } from '@angular/core';
import {RouterModule} from '@angular/router';
import {InformationComponent} from "./information/information.component";
import {DigitalinlistComponent} from "./digitalin/digitalinlist/digitalinlist.component";
import {DigitaloutlistComponent} from "./digitalout/digtaloutlist/digitaloutlist.component";
import {AnalogoutlistComponent} from "./analogout/analogoutlist/analogoutlist.component";
import { ModbuslistComponent} from "./modbus/modbuslister/modbuslist.component";
import {FrequencylistComponent} from "./frequency/frequencylist/frequencylist.component";
import {CounterlistComponent} from "./counter/counterlist/counterlist.component";
import {AnalyserComponent} from "./analyser/analyser/analyser.component";
import {MappedservolisterComponent} from "./mappedservo/mappedservolister/mappedservolister.component";
import {DmesglogComponent} from "./dmesglog/dmesglog/dmesglog.component";
import {ClimatelogComponent} from "./climatelog/climatelog/climatelog.component";
import {QueueComponent} from "./queue/queue/queue.component";
import {MeasurementSlotListComponent} from "./measurementsslots/measurementslot-list/measurement-slot-list.component";
import {AnaloginlistComponent} from "./analogin/analoginlist/analoginlist.component";
import {CalibrationComponent} from "./calibration/calibration/calibration.component";
import {ListclientsComponent} from "./listclients/listclients/listclients.component";
import {UserprofileComponent} from "./userprofile/userprofile.component";
import {WifiMenuDataComponent} from "./wifi-menu-data/wifi-menu-data.component";
import {MeasurementListComponent} from "./measurements/measurement-list/measurement-list.component";
import {CardComputerOverviewComponent} from "./cards/card-computer-overview/card-computer-overview.component";
import {ComplexDevicesListComponent} from "./complex-devices/complex-devices-list/complex-devices-list.component";
import {FastlinkmonitorComponent} from "./fastlinkmonitor/fastlinkmonitor/fastlinkmonitor.component";
import {IrrigationValveComponent} from "./cards/custom_views/irrigation-valve/irrigation-valve.component";
import {HeatmapComponent} from "./cards/heatmap/heatmap.component";
import {ClientsComponent} from "./clients/clients.component";


const routers  = [
  {  path: 'list',                        component: ClientsComponent},
  {  path: 'cards',                       component: CardComputerOverviewComponent },
  {  path: 'fastlinkmonitor',             component: FastlinkmonitorComponent},
  {  path: 'complex',                     component: ComplexDevicesListComponent},
  {  path: 'digitalout',                  component: DigitaloutlistComponent},
  {  path: 'digitalin',                   component: DigitalinlistComponent},
  {  path: 'frequency',                   component: FrequencylistComponent},
  {  path: 'counter',                     component: CounterlistComponent},
  {  path: 'analogout',                   component: AnalogoutlistComponent},
  {  path: 'analogin',                    component: AnaloginlistComponent},

  {  path: 'information',                 component: InformationComponent},
  {  path: 'modbus',                      component: ModbuslistComponent},
  {  path: 'mappedservo',                 component: MappedservolisterComponent },
  {  path: 'analyser',                    component: AnalyserComponent },

  {  path: 'dmesglog',                    component: DmesglogComponent },
  {  path: 'measurementsslots',           component: MeasurementSlotListComponent },
  {  path: 'climatelog',                  component: ClimatelogComponent },
  {  path: 'queue',                       component: QueueComponent },

  {  path: 'calibration',                 component: CalibrationComponent },
  {  path: 'wifi',                        component: WifiMenuDataComponent },

  {  path: 'user',                        component: UserprofileComponent},

  {  path: 'measurements',                component: MeasurementListComponent},
  {  path: 'valveoverview',               component: IrrigationValveComponent},

  {  path: 'list',                        component: ListclientsComponent},

  {  path: 'heatmap',                     component: HeatmapComponent },



  {  path: '',   redirectTo: 'list', pathMatch: 'full'},
  {  path: '**', redirectTo: 'list', pathMatch: 'full'}
];


@NgModule({
  imports: [RouterModule.forRoot(routers)],
  exports: [RouterModule]}
)
export class AppRoutingModule
{


}
